<template>
  <section class="file-info-panel">
    <header class="header">
      <h3>{{ file.name }}</h3>
      <close-button @click="$modal.hideAll()"></close-button>
    </header>
    <main class="main">
      <dl>
        <dt>Naam</dt>
        <dd>{{ file.name }}</dd>
        <dt>Locatie</dt>
        <dd>{{ fileLocation }}</dd>
        <dt>Grootte</dt>
        <dd>{{ $filters.formatFileSize(file.fileSize) }}</dd>
        <!--        <template v-if="file.type === 'folder'">-->
        <!--          <dt>Aantal bestanden</dt>-->
        <!--          <dd>{{ file.name }}</dd>-->
        <!--        </template>-->
        <dt>Toegevoegd op</dt>
        <dd>
          {{ $filters.formatDate(file.created) }} om
          {{ $filters.formatTime(file.created) }}
        </dd>
        <dt>Toegevoegd door</dt>
        <dd>{{ file.creator }}</dd>
      </dl>
    </main>
  </section>
</template>

<script>
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'

export default {
  name: 'FileInfo',
  props: ['file'],
  computed: {
    ...mapStores(useFileStoreStore),
    fileLocation() {
      const id =
        this.file.type === 'file' ? this.file.folderId : this.file.parentId
      const levels = this.fileStoreStore.getFolderPath(id)
      return (
        '/' + levels.map((level) => level.name).join('/') + '/' + this.file.name
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.file-info-panel {
  padding: 25px;

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    h3 {
      font-size: 15px;
      font-weight: 500;
      color: var(--sub-color);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .main {
    dl {
      display: flex;
      flex-flow: row wrap;
      line-height: 28px;
      dt {
        flex-basis: 30%;
      }
      dd {
        flex-basis: 70%;
        //white-space: nowrap;
        //text-overflow: ellipsis;
        //overflow: hidden;
      }
    }
  }
}
</style>
